import { AboutService } from './about.service';
import { jwtDecode } from 'jwt-decode';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { IUser } from '../Models/IUser';
import { IDecodedToken } from '../interfaces/callerInterfaces';
import { ApiCallerService } from './api-caller.service';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public currentUser: BehaviorSubject<IDecodedToken> = new BehaviorSubject(
    {} as IDecodedToken
  );
  public isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject(false);
  TOKEN_KEY = 'e-serviceToken';

  constructor(private http: HttpClient, private router: Router ) {}
  logIn(loginInfo: any) {
    return this.http.post<any>(
      environment.apiUrl + 'account/login',
      loginInfo,
      this.generateHeaders()
    );
  }

  loginWithAccessToken(accessToken: string) {
    return this.http.post<any>(
      environment.apiUrl + 'account/loginWithToken',
      {
        accessToken: accessToken,
      },
      this.generateHeaders()
    );
  }

  // isAuthenticated(): boolean {
  //   const localstorage = this.getToken();
  //   return localstorage == null ? false : true;
  // }
  private generateHeaders() {
    let _headers = {};
    if (this.isAuthenticated.getValue()) {
      const token = 'Bearer ' + this.getToken();
      _headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token,
        'ngrok-skip-browser-warning': 'true',
      });
    } else {
      _headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    return {
      headers: _headers,
    };
  }
  getToken() {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      return sessionStorage.getItem(this.TOKEN_KEY);
    }
    return null;
  }
  setToken(token: string) {
    sessionStorage.setItem(this.TOKEN_KEY, token);
  }
  public removeToken() {
    sessionStorage.removeItem(this.TOKEN_KEY);
  }

  public get DecodedToken(): IDecodedToken {
    return jwtDecode(this.Token);
  }

  public get Token(): string {
    return sessionStorage.getItem(this.TOKEN_KEY) ?? '';
  }

  public CheckUser() {
    if (this.Token) {
      this.isAuthenticated.next(true);
      this.currentUser.next(this.DecodedToken);
    }
    else this.isAuthenticated.next(false);
  }

  get isTypeUser(): boolean {
    return this.currentUser.getValue().userType == 'user';
  }

  get isTypeEmployee(): boolean {
    return this.currentUser.getValue().userType == 'employee';
  }
}
